import { render, staticRenderFns } from "./survey-modal.vue?vue&type=template&id=74fe35c9&scoped=true&"
import script from "./survey-modal.vue?vue&type=script&lang=js&"
export * from "./survey-modal.vue?vue&type=script&lang=js&"
import style0 from "./survey-modal.vue?vue&type=style&index=0&id=74fe35c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fe35c9",
  null
  
)

export default component.exports